/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getArrayItems } from '../../utils/FormatFunctions';
import { RowIdentity } from '../../components/ui';
import { useAuth } from '../../providers/auth';

export function ResponsiblePage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/users?group_id=5`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();
  const navigate = useNavigate();
  const groupIds = user?.group?.id;

  const columns = [
    { name: 'name', label: 'Nome' },
    { name: 'childrens', label: 'Filhos' },
  ];

  return (
    <Box>
      <PageTitle description="Consulte os responsáveis e os alunos vinculados a cada um.">
        Responsáveis
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 3 ? true : false}
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        columnWithAction={[
          {
            name: 'name',
            columnAction: (rowItem) => (
              <RowIdentity
                title={rowItem?.name}
                meta={rowItem?.email}
                image={rowItem?.image?.medium}
              />
            ),
          },
          {
            name: 'childrens',
            columnAction: (rowItem) => (
              <Button size="xs" variant="outline" onClick={() => navigate(`${rowItem.id}`)}>
                Ver filhos
              </Button>
            ),
          },
        ]}
        formatColum={[
          {
            field: 'institutions',
            formatField: getArrayItems,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
